import { memo } from 'react';
import { useStore } from '@/store';
import { LandmarkPoetryPlaceInfo } from '@/store/types';
import { useSpring, animated } from '@react-spring/web';
import styles from './index.module.scss';
import { getAssetUrl } from '@/utils/common';
import { LandmarkPoetryPlaceDetailType } from '@/store/types';

interface PoetrySpotProps {
  place: LandmarkPoetryPlaceInfo;
  index: number;
}

const PoetrySpot = ({ place, index }: PoetrySpotProps) => {
  const setLandmarkPoetryMode = useStore((state) => state.setLandmarkPoetryMode);

  // const spring = useSpring({
  //   from: { scale: 0, opacity: 0 },
  //   to: { scale: 1, opacity: 1 },
  //   delay: index * 50,
  //   config: {
  //     tension: 180*2,
  //     friction: 12,
  //   }
  // });
  const HighlightNumbers = (text: string) => {
    const parts = text?.split(/(\d+)/).filter(Boolean) || [];
    return (
      <div>
        {parts.map((part, index) => (
          // 如果是数字，则用<span>包裹并应用样式
          <span key={index} style={{ 
            fontSize: part.match(/^\d+$/) ? '20px' : '16.9px',
            fontWeight: part.match(/^\d+$/) ? 700 : 400,
          }}>
            {part}
          </span>
        ))}
      </div>
    );
  }

  return (
    <animated.div
      className={styles.poetrySpot}
      style={{
        // left: place.x,
        // top: place.y,
        // ...spring
        width: 'max-content',
      }}
      onClick={() => setLandmarkPoetryMode(place.entity_id, LandmarkPoetryPlaceDetailType.POET)}
      // onDoubleClick={() => setLandmarkPoetryPlaceDetail({type: 2,...place})}
    >
      <div className={styles.poetrySpotContent}
      style={
        (place?.short_summary?.length || 7) < 8  ?
        {backgroundImage: `url(${getAssetUrl("images/landmark/poetryicon1.svg")})`, width: '202px'}: 
        {backgroundImage: `url(${getAssetUrl("images/landmark/poetryicon.svg")})`, width: '298px'}

      }
      >
        <p className={styles.name}>{place.name}</p>
        <p className={styles.summary}>{HighlightNumbers(place?.short_summary || '')}</p>
      </div>
    </animated.div>
  );
};

export default memo(PoetrySpot); 